import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteExternalConnection } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

import { queryKey as externalEventsQueryKey } from './use-external-calendar-events-query';

export const useDeleteExternalConnectionMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async (id: ID) => {
      await deleteExternalConnection(id);
      // not snapshot-backed — manual invalidate required so the derived
      // external-calendar-events query re-fetches after disconnect.
      await client.invalidateQueries({ queryKey: [externalEventsQueryKey] });
    },
  });
};
